import { fetchPropertyInformation } from '@app/services/propertyService'
import { useQuery } from '@tanstack/react-query'

export const useFetchPropertyInformation = (assetType?: string, assetId?: string) => {
  return useQuery({
    queryKey: ['propertyInformation', assetType, assetId],
    queryFn: () => fetchPropertyInformation(assetType, assetId || ''),
    enabled: !!assetType && !!assetId,
  })
}
